(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[566],{

/***/ 8821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/premarket",
      function () {
        return __webpack_require__(1051);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": function() { return /* binding */ TableBody; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "xD": function() { return /* binding */ TableHeader; },
/* harmony export */   "xs": function() { return /* binding */ TableHeaderCell; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Table_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9838);
/* harmony import */ var _Table_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Table_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utilities_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3555);
/* harmony import */ var _Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3__);




const Table = (param)=>/*#__PURE__*/ {
    let { children , className , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
        className: "".concat((_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().table), " ").concat(className),
        style: style,
        children: children
    });
};
const TableRow = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableRow),
        style: style,
        children: children
    });
};
const TableHeader = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableHeader),
        style: style,
        children: children
    });
};
const TableBody = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableBody),
        style: style,
        children: children
    });
};
const TableHeaderCell = (param)=>{
    let { children , className , style , align ="left" , hideOnMobile  } = param;
    let computedClasses = className !== null && className !== void 0 ? className : "";
    // Alignment
    computedClasses += align === "right" ? " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignRight)) : " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignLeft));
    // Hide on mobile
    computedClasses += hideOnMobile ? " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().hide)) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        className: computedClasses,
        style: style,
        children: children
    });
};
const TableCell = (param)=>{
    let { children , className , style , align ="left" , numberType , hideOnMobile , shortenOnMobile =false  } = param;
    let computedClasses = className !== null && className !== void 0 ? className : "";
    // Alignment
    if (align === "right") {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignRight));
    } else {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignLeft));
    }
    // Text color
    if (numberType) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default())[numberType]);
    }
    // Hide on mobile
    if (hideOnMobile) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().hide));
    }
    // Ellipsis for long text
    if (shortenOnMobile) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().ellipsis));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        className: computedClasses,
        style: style,
        children: children
    });
};



/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);




const AppLayout = (param)=>{
    let { title , children , robots  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    robots && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: robots
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "https://www.fuw.ch/_static/dnd_iframe_autofit_child.js",
                strategy: "beforeInteractive"
            })
        ]
    });
};
if (true) {
    // Dark Mode, Step 1:
    // we are checking/setting system dark mode by ourselves (this must be before step 2!)
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        if (document.body) {
            document.body.classList.add("dark");
        }
    }
    // Dark Mode, Step 2:
    // registering message events from Disco
    window.addEventListener("message", (event)=>{
        if (event.origin.indexOf("fuw.ch") !== -1 && event.data.type === "colorMode") {
            if (event.data.mode === "dark") {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppLayout);


/***/ }),

/***/ 1051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ premarket; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/layout/AppLayout.tsx
var AppLayout = __webpack_require__(1835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/dataDisplay/premarketTable/premarket.module.css
var premarket_module = __webpack_require__(1917);
var premarket_module_default = /*#__PURE__*/__webpack_require__.n(premarket_module);
;// CONCATENATED MODULE: ./src/components/dataDisplay/premarketTable/Closed.tsx


const Closed = (param)=>{
    let { message  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (premarket_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            style: {
                textAlign: "left"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: message
            })
        })
    });
};
/* harmony default export */ var premarketTable_Closed = (Closed);

// EXTERNAL MODULE: ./src/components/dataDisplay/table/Table.tsx
var Table = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/dataDisplay/premarketTable/IndexTable.tsx


const IndexTable = (param)=>{
    let { segment  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* Table */.iA, {
        style: {
            marginBottom: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeader */.xD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            children: "Basiswert"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "Last"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "Change"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableBody */.RM, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                            children: segment.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                            align: "right",
                            children: segment.titleInstrument.mid
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                            align: "right",
                            numberType: "".concat(segment.titleInstrument.change.startsWith("-") ? "negative" : "positive"),
                            children: segment.titleInstrument.change
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableCell */.pj, {
                            align: "right",
                            numberType: "".concat(segment.titleInstrument.changePercent.startsWith("-") ? "negative" : "positive"),
                            children: [
                                segment.titleInstrument.changePercent,
                                "%"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var premarketTable_IndexTable = (IndexTable);

;// CONCATENATED MODULE: ./src/components/dataDisplay/premarketTable/InstrumentsTable.tsx



const InstrumentsTable = (param)=>{
    let { instruments  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* Table */.iA, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeader */.xD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            children: "Basiswert"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            hideOnMobile: true,
                            children: "Size"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "Geld"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "Brief"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            className: (premarket_module_default()).hide,
                            children: "Size"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            hideOnMobile: true,
                            children: "Change"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableHeaderCell */.xs, {
                            align: "right",
                            children: "%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableBody */.RM, {
                children: instruments.map((instrument)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                shortenOnMobile: true,
                                children: instrument.shortName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                align: "right",
                                hideOnMobile: true,
                                children: instrument.bidSize
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                align: "right",
                                className: (premarket_module_default()).bold,
                                children: instrument.bid
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                align: "right",
                                className: (premarket_module_default()).bold,
                                children: instrument.ask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                align: "right",
                                hideOnMobile: true,
                                children: instrument.askSize
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                align: "right",
                                hideOnMobile: true,
                                numberType: "".concat(instrument.change.startsWith("-") ? "negative" : "positive"),
                                children: instrument.change
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableCell */.pj, {
                                align: "right",
                                numberType: "".concat(instrument.changePercent.startsWith("-") ? "negative" : "positive"),
                                children: [
                                    instrument.changePercent,
                                    "%"
                                ]
                            })
                        ]
                    }, instrument.shortName))
            })
        ]
    });
};
/* harmony default export */ var premarketTable_InstrumentsTable = (InstrumentsTable);

// EXTERNAL MODULE: ./src/utils/time.tsx
var time = __webpack_require__(6972);
;// CONCATENATED MODULE: ./src/components/dataDisplay/premarketTable/Footer.tsx



const Footer = (param)=>{
    let { timestamp  } = param;
    const formattedDate = (0,time/* formatDate */.p6)(timestamp);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (premarket_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Index is calculated by Julius Baer based on mid prices. Premarket data may not be delivered to any other professional Information Supplier Provider without prior approval by Julius Baer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Last updated",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            marginLeft: "5px"
                        },
                        children: formattedDate
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var premarketTable_Footer = (Footer);

;// CONCATENATED MODULE: ./src/pages/embed/premarket.tsx








const Premarket = (response)=>{
    const [segmentHead, setSegmentHead] = (0,react.useState)(0);
    let output = null;
    if (response.message) {
        output = /*#__PURE__*/ (0,jsx_runtime.jsx)(premarketTable_Closed, {
            message: response.message
        });
    }
    if (response.data) {
        output = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (premarket_module_default()).tabs,
                    children: response.data.segments.map((segment, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "".concat((premarket_module_default()).tab, " ").concat(segmentHead == i ? (premarket_module_default()).active : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>setSegmentHead(i),
                                children: segment.name
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(premarketTable_IndexTable, {
                    segment: response.data.segments[segmentHead]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: (premarket_module_default()).divider
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(premarketTable_InstrumentsTable, {
                    instruments: response.data.segments[segmentHead].instruments
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(premarketTable_Footer, {
                    timestamp: response.data.creationTimestamp
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        title: "Premarket",
        robots: "noindex,nofollow",
        children: output
    });
};
var __N_SSP = true;
/* harmony default export */ var premarket = (Premarket);


/***/ }),

/***/ 6972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "zk": function() { return /* binding */ isToday; }
/* harmony export */ });
/* unused harmony export convertUTCToFuWTime */
function isToday(date) {
    const today = new Date();
    return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
}
function convertUTCToFuWTime(IsoStringUTC) {
    const d = new Date(IsoStringUTC);
    const tzo = -d.getTimezoneOffset();
    const dif = tzo >= 0 ? "+" : "-";
    const pad = (num)=>{
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? "0" : "") + norm;
    };
    return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()) + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds()) + dif + pad(tzo / 60) + ":" + pad(tzo % 60);
}
function convertTimestampToDate(date) {
    if (date !== undefined) {
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("de-CH", {
            hour: "2-digit",
            minute: "2-digit",
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    } else {
        return "Invalid date";
    }
}
function formatDate(timestamp) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "de-CH";
    return new Date(timestamp).toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}



/***/ }),

/***/ 3555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"Utilities_alignLeft__MxRYq","alignRight":"Utilities_alignRight__dtYUv","negative":"Utilities_negative__LZUxg","positive":"Utilities_positive__eyzkl","hide":"Utilities_hide__HNfTN","ellipsis":"Utilities_ellipsis__MMn_A"};

/***/ }),

/***/ 1917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"premarket_tabs__8Ekvw","tab":"premarket_tab__pbqrX","active":"premarket_active__c69M3","bold":"premarket_bold__WXQy2","hide":"premarket_hide__pzDah","footer":"premarket_footer__QOBVp","divider":"premarket_divider__A0D6k"};

/***/ }),

/***/ 9838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__xpk7y","tableHeader":"Table_tableHeader__HLcE7","tableBody":"Table_tableBody__JuauZ"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);